module.exports = __webpack_public_path__ + "static/media/burroughs.75668fff.jpg";